import { Model } from 'libx'
import moment from 'moment'
import { observable, computed } from 'mobx'

export class Coupon extends Model {
  @observable id
  @observable friendlyName
  @observable description
  @observable couponType
  @observable offType
  @observable duration
  @observable dateExpires

  @computed get expired () {
    return this.dateExpires && this.dateExpires.isBefore(moment())
  }

  parse (json) {
    return {
      ...json,
      dateExpires: json.dateExpires
        ? moment(json.dateExpires)
        : null
    }
  }
}

export class UserCoupon extends Model {
  @observable userId
  @observable redeemed = false
  @observable dateCreated = moment()
  @observable dateRedeemed = null

  parse (json) {
    return {
      ...json,
      dateCreated: moment(json.dateCreated),
      dateRedeemed: json.dateRedeemed
        ? moment(json.dateRedeemed)
        : null,
      coupon: new Coupon(json.coupon, { rootStore: this.rootStore, parse: true })
    }
  }
}



// WEBPACK FOOTER //
// ./src/client/domain/Coupon.js